<template>
    <div v-if="cnaeList">
        <div class="flex justify-between items-center mb-4">
            <h2 class="text-2xl font-bold">{{ cnaeList.name }}</h2>
            <div class="flex items-center">
                <label for="show-deleted" class="mr-2">Mostrar Excluídos</label>
                <ToggleSwitch id="show-deleted" v-model="showDeleted" />
            </div>
        </div>

        <DataTable :value="filteredItems" responsiveLayout="scroll" paginator :rows="10" emptyMessage="Nenhum código CNAE para exibir.">
            <Column field="formatted_cnae_code" header="Código CNAE"></Column>
            <Column header="Descrição">
                <template #body="slotProps">
                    {{ getDescription(slotProps.data.cnae_code) }}
                </template>
            </Column>
            <Column header="Adicionado em">
                <template #body="slotProps">
                    {{ formatDate(slotProps.data.inserted_at) }}
                </template>
            </Column>
            <Column v-if="showDeleted" header="Excluído em">
                <template #body="slotProps">
                    {{ slotProps.data.deleted_at ? formatDate(slotProps.data.deleted_at) : '-' }}
                </template>
            </Column>
            <Column v-if="showDeleted" header="Excluído por">
                <template #body="slotProps">
                    {{ slotProps.data.deleted_by?.name || slotProps.data.deleted_by?.email || '-' }}
                </template>
            </Column>
        </DataTable>
    </div>
</template>

<script setup lang="ts">
import { ref, computed } from 'vue';
import type { CnaeList } from '@/types/cnaeList';
import DataTable from 'primevue/datatable';
import Column from 'primevue/column';
import ToggleSwitch from 'primevue/toggleswitch';
import cnaeData from '@/assets/cnae_descriptions.json';
import { type CnaeDescription } from '@/types/cnaeList'
import { formatDate } from '@/utils/formatters';

const cnaeDescriptions: Record<string, CnaeDescription> = cnaeData;

const props = defineProps<{ cnaeList: CnaeList | null }>();

const showDeleted = ref(false);

const filteredItems = computed(() => {
    if (!props.cnaeList) return [];
    if (showDeleted.value) {
        return props.cnaeList.items;
    }
    return props.cnaeList.items.filter(item => !item.deleted_at);
});

function getDescription(code: string): string {
    return cnaeDescriptions[code]?.description || '';
}

</script>
